var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 47,
    viewBox: "0 0 26 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7905 26.3018L25.1184 17.8722H16.9384V12.3929C16.9384 10.0879 18.0804 7.83558 21.7322 7.83558H25.5035V0.657189C23.3073 0.30728 21.0881 0.117981 18.8639 0.0908203C12.1313 0.0908203 7.73588 4.13443 7.73588 11.4445V17.8722H0.272949V26.3018H7.73588V46.6911H16.9384V26.3018H23.7905Z",
    fill: "#3B5998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.460047f2658f48b40a37728ff719c6a7.svg";
export { ForwardRef as ReactComponent };